module.exports = __webpack_public_path__ + "img/modulo-3.8970790f.svg";